import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as itemsActions from 'store/modules/items';

import ItemDetailWeaponContainer from 'containers/items/ItemDetailWeaponContainer';
import ItemDetailArmmorContainer from 'containers/items/ItemDetailArmmorContainer';
import ItemDetailAcCtContainer from 'containers/items/ItemDetailAcCtContainer';

import StatInvenContainer from 'containers/items/StatInvenContainer';

import {Link} from 'react-router-dom';

class ItemSelectContainer extends Component {
  
  async componentDidMount() {
    const {ItemsActions, id, itemList} = this.props;
    // const {list01} = itemList;
    // const list01Cnt = list01.length;
    
    //URL을 통해 바로 아이템상세로 들어온경우
    const exists = Object.values(itemList).some(list =>
      list.some(item => item.ITEM_SEQ === id)
    );

    if(!exists) await this.getItemView(id);
    
    if(id){
      await this.onClickItemDtl(id);
    }

    const {itemFilters, itemList: beforeItemList} = this.props;
    const {itemKind} = itemFilters;
    const listCurrKindCnt = beforeItemList[`list${itemKind}`].length;
    
    //선택한거 한개만 있는경우
    if(listCurrKindCnt === 1) await ItemsActions.getItemList(itemKind);
    
  }

  getItemView = async (itemSeq) => {
    const {ItemsActions} = this.props;
    await ItemsActions.getItemView(itemSeq);
  }

  onClickItemDtl = (itemSeq) => {
    const {ItemsActions, myStat} = this.props;
    const {selSkillSeq} = myStat;
    // const {itemKind} = itemFilters;
    const isView = '';
    // console.log('onClickItemDtl')
    // if(itemKind !== '03' && itemKind !== '06') { //방패,코튬날개
      ItemsActions.ctrlItemDtlPopup({isView, itemSeq, selSkillSeq});
    // }

  }

  render() {
    const {itemFilters} = this.props;
    const {itemKind} = itemFilters;
    const style = {
      // display:'flex', 
      // justifyContent:'space-around', 
      // flexWrap:'wrap'

      display: 'flex',
      gap: '40px',
      maxWidth: '970px',
      width: '100%',
      flexWrap: 'wrap'

      // display: 'flex',
      // flexDirection: 'column', /* 위아래 배치 */
      // gap: '20px' /* 두 div 사이 간격 */
    }

    return (
      itemKind === '01' || itemKind === '02' ?
      <div style={style}>
        <ItemDetailWeaponContainer/>
        <StatInvenContainer/>
      </div>
      : itemKind === '04' || itemKind === '03' ?
      <div style={style}>
        <ItemDetailArmmorContainer/>
        {/* {itemKind === '04' ? <StatInvenContainer/> : null} */}
      </div>
      : itemKind === '05' || itemKind === '06' ?
      <div style={style}><ItemDetailAcCtContainer/></div> : <div><Link to='/'>홈으로</Link></div>
    );
  }
}

export default connect(
  (state) => ({
    // currSelWeapon: state.items.toJS().currSelWeapon,
    itemList: state.items.toJS().itemList,
    itemFilters: state.items.toJS().itemFilters,
    myStat: state.calc.toJS().myStat
  }),
  (dispatch) => ({
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(ItemSelectContainer);